import OnlineAppComponent from "../lib/online_app_component";

export const OnlineAppFooterConfig = {
    baseHtmlClass: 'online_app__footer',
    selector: '.online_app__footer'
}

export class OnlineAppFooter extends OnlineAppComponent {

    constructor(id_or_element, onlineApp) {
        super(id_or_element, onlineApp, OnlineAppFooterConfig);
        this.closer = this.adoptChildComponents(new FooterCloser(this));

        // The onlineApp singleton outlives this footer's element, so clear its back-reference on
        // destroy (=== this so a replacement footer is not nulled). The footer also removes its own
        // element — it can be destroyed by hand (FooterCloser.destroyFooter) while still on-page,
        // where the base destroy() alone would leave the element in the DOM.
        this.onDestroy(() => { if (this.onlineApp?.footer === this) this.onlineApp.footer = null; });
        this.onDestroy(() => this.element?.remove());

        this.render();
    }

    getHeight() {
        try {
            return this.element.offsetHeight;
        } catch {
            return 0;
        }
    }

    // No destroy() override — the back-ref null and own-element removal are registered via
    // onDestroy() in the constructor, and the FooterCloser child is adopted, so the base
    // Component#destroy() runs them and deregisters this footer.

    render() {
        this.swapHtmlClassStates(this.readStateMachineValue('footerOpen'), 'open', 'closed');
    }

}

export function getFooter(element, onlineApp) {
    if (!element) return null;
    return new OnlineAppFooter(element, onlineApp);
}


const FooterCloserConfig = {
    baseHtmlClass: 'online_app__footer__closer'
}

export class FooterCloser extends OnlineAppComponent {

    constructor(onlineAppFooter) {
        super(null, onlineAppFooter.onlineApp, FooterCloserConfig);
        this.element = FooterCloser.createElement(FooterCloserConfig.baseHtmlClass);
        this.onlineAppFooter = onlineAppFooter;
        this.onlineAppFooter.element.appendChild(this.element);

        this.element.addEventListener('click', (event) => {
            this.dispatchAction('footerCloserSelected', this);
        });

    }

    renderContent() {
        this.element.innerHTML = this.content;
    }

    render() {
        this.content = '✗';
        this.renderContent();
    }

    destroyFooter() {
        if (this.onlineAppFooter) this.onlineAppFooter.destroy();
    }
}
